"use strict";
// Application-layer error codes for the impersonation feature (spec 048).
// These are NOT Anchor contract errors — they are TypeScript-only codes
// shared between frontend (override layer) and backend (enforcement layer).
// See frontend/specs/048-impersonate-user/supplementary/research.md R-16.
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPERSONATION_ERRORS = void 0;
exports.isImpersonationErrorCode = isImpersonationErrorCode;
exports.getImpersonationError = getImpersonationError;
exports.IMPERSONATION_ERRORS = {
    IMPERSONATION_BLOCKED_TX: {
        code: 'IMPERSONATION_BLOCKED_TX',
        httpStatus: 403,
        msg: 'Transaction submission blocked while impersonating a user',
    },
    IMPERSONATION_BLOCKED_SIGNING: {
        code: 'IMPERSONATION_BLOCKED_SIGNING',
        httpStatus: 403,
        msg: 'Turnkey signing blocked while impersonating a user',
    },
    IMPERSONATION_BLOCKED_MUTATION: {
        code: 'IMPERSONATION_BLOCKED_MUTATION',
        httpStatus: 403,
        msg: 'SDK mutation blocked while impersonating a user',
    },
    IMPERSONATION_GRANT_INVALID: {
        code: 'IMPERSONATION_GRANT_INVALID',
        httpStatus: 401,
        msg: 'Impersonation grant is invalid or could not be verified',
    },
    IMPERSONATION_GRANT_EXPIRED: {
        code: 'IMPERSONATION_GRANT_EXPIRED',
        httpStatus: 401,
        msg: 'Impersonation grant has expired',
    },
    IMPERSONATION_METHOD_BLOCKED: {
        code: 'IMPERSONATION_METHOD_BLOCKED',
        httpStatus: 403,
        msg: 'HTTP method not permitted while impersonating',
    },
    IMPERSONATION_ALLOWLIST_DENIED: {
        code: 'IMPERSONATION_ALLOWLIST_DENIED',
        httpStatus: 403,
        msg: 'Engineer is not on the impersonation allowlist',
    },
    IMPERSONATION_STEP_UP_REQUIRED: {
        code: 'IMPERSONATION_STEP_UP_REQUIRED',
        httpStatus: 403,
        msg: 'Fresh authentication required before impersonating',
    },
    IMPERSONATION_RATE_LIMIT_EXCEEDED: {
        code: 'IMPERSONATION_RATE_LIMIT_EXCEEDED',
        httpStatus: 429,
        msg: 'Impersonation rate limit exceeded',
    },
    IMPERSONATION_REASON_REQUIRED: {
        code: 'IMPERSONATION_REASON_REQUIRED',
        httpStatus: 400,
        msg: 'Reason is required for mainnet impersonation',
    },
    IMPERSONATION_AUDIT_UNAVAILABLE: {
        code: 'IMPERSONATION_AUDIT_UNAVAILABLE',
        httpStatus: 503,
        msg: 'Impersonation audit log writer is unavailable',
    },
    STEP_UP_FAILED: {
        code: 'STEP_UP_FAILED',
        httpStatus: 401,
        msg: 'Step-up authentication failed',
    },
};
const IMPERSONATION_ERROR_NAMES = new Set(Object.keys(exports.IMPERSONATION_ERRORS));
function isImpersonationErrorCode(code) {
    return IMPERSONATION_ERROR_NAMES.has(code);
}
function getImpersonationError(code) {
    return exports.IMPERSONATION_ERRORS[code];
}
